<template>
  <div id="static-document-page"
      class="align-items-center justify-content-center" :class="{'viewport viewport-with-top-nav viewport-compact' : !hideTopNav}">
    <spinner v-if="!content" class="align-content-center"></spinner>
    <template v-else>
      <TopNav v-if="!hideTopNav" :titleKey="titleKey"/>
      <div v-html="content" id="content"></div>
      <div class="flex-grow-1"></div>
    </template>
  </div>
</template>

<script>
  import TopNav from '@shared/components/TopNav'
  import axios from 'axios'
  import i18n from '@shared/module/i18n'

  export default {
    name: 'StaticDocumentPage',
    components: { TopNav },
    props: ['documentName', 'locale', 'hideTopNav', 'titleKey'],
    data () {
      return {
        content: null,
        language: this.locale || i18n.locale
      }
    },
    mounted() {
      if (this.locale === 'al') {
        if (this.documentName === 'privacy-policy') {
          window.location.replace('https://iutecredit.al/politika-e-privatesise/?w')
        } else if (this.documentName === 'credit-registry-consent') {
          window.location.replace('https://www.iutecredit.al/klauzola-e-pelqimit-paraprak/?w')
        } else if (this.documentName === 'general-terms') {
          window.location.replace('https://www.iutecredit.al/about/conditions/?w')
        } else if (this.documentName === 'pep-consent') {
          window.location.replace('https://www.iutecredit.al/njoftim-mbi-statusin-e-personave-te-ekspozuar-politikisht-pep/  ?w')
        }
      } else {
        axios.get(`/terms/${this.documentName}-${this.language}.htm`).then(result => {
          this.content = result.data
        })
      }
    }
  }
</script>
